import React from 'react';

export default function ItemCardapio({ item, onAdd, mostrarBotao }) {
  return (
    <div className="p-4 border rounded shadow-md bg-white hover:shadow-lg transition-all">
      <h3 className="text-lg font-bold mb-1">{item.titulo}</h3>
      <p className="text-sm text-gray-600 mb-2">{item.descricao}</p>
      <p className="font-semibold mb-2">R$ {parseFloat(item.preco).toFixed(2)}</p>

      {mostrarBotao && (
        <button
          onClick={() => onAdd(item)}
          className="mt-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white font-bold rounded-full transition-all"
        >
          Pedir
        </button>
      )}
    </div>
  );
}
